import { EnhancedConclusionsDetailPage } from "pages/ConclusionsDetailPage"

const Conclusion = p => <EnhancedConclusionsDetailPage {...p} isPreassessment />

export default Conclusion
